import { Box, CardContent, Skeleton, Stack } from "@mui/material";
import {
  List,
  ListItem,
  ListItemIconSkeleton,
  ListItemTextSkeleton,
  PillSkeleton,
} from "@src/appV2/redesign/system/ui-components";

import { WorkplaceHighlightPills } from "../../Workplace/Highlights/Pills";

export function VisitBottomSheetSkeleton() {
  return (
    <Box sx={{ overflowY: "auto", width: "100%" }}>
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 7,
        }}
      >
        <PillSkeleton />
        <Skeleton variant="text" width="70%" height="25%" />
        <Skeleton variant="text" width="85%" height="25%" />
        <Skeleton variant="text" width="65%" height="25%" />
      </CardContent>

      <List>
        <ListItem divider>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="35%" secondaryWidth="30%" />
        </ListItem>

        <ListItem sx={{ paddingBottom: 4 }}>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>

        <Stack spacing={4} sx={{ paddingTop: 4, ml: "2rem" }}>
          <WorkplaceHighlightPills isLoading highlights={[]} />

          <Skeleton sx={{ height: "13rem", width: "100%" }} />
        </Stack>
      </List>
    </Box>
  );
}
